import React from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  Typography,
  IconButton,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  djangoHandleDataRequests,
  handleSpringDataMutationRequest,
} from "../../../../api";
import { toast } from "material-react-toastify";
import { useEffect } from "react";

const AddUpdatePackageConfig = ({
  setOpenAddEditConfig,
  singleSpaceInfo,
  selectedRoom,
  setGridRefresh,
}) => {
  console.log("singleSpaceInfo", singleSpaceInfo);

  const zeroTax = [
    {
      id: 0,
      is_group_tax: "false",
      name: "Tax",
      percentage: 0,
      province: "India",
    },
  ];
  const [taxes, setTaxes] = useState([]);

  const [name, setName] = useState("");
  const [area, setArea] = useState("");
  const [perPersonCost, setPerPersonCost] = useState(0);
  const [taxId, setTaxId] = useState(0);
  const [perChildCost, setPerChildCost] = useState(0);
  const [loading, setLoading] = useState(false);

  const getAllTaxes = async () => {
    try {
      const [taxes, groupTaxes] = await Promise.all([
        djangoHandleDataRequests("tax/getAllTaxCategories"),
        djangoHandleDataRequests("grouptax/getAllGroupTaxCategories"),
      ]);

      const formattedGrpTaxes = groupTaxes.map((grpTax) => ({
        id: grpTax?.id,
        name: grpTax?.name,
        province: "India",
        percentage: (grpTax?.tax_components || [])?.reduce((acc, curr) => {
          return acc + (curr?.tax_percentage || 0);
        }, 0),
        is_group_tax: "true",
      }));

      const allTaxes = [...zeroTax, ...taxes, ...formattedGrpTaxes];
      setTaxes(allTaxes);
    } catch {
      toast.error("Error in fetching the taxes. Contact the support team.");
    }
  };
  const handleAddUpdateSpace = () => {
    if (!name?.trim()) {
      toast.error("Please enter a valid package name.");
      return;
    }
    const payload = {
      id: selectedRoom?.id || null,
      nonRentalTypeId: singleSpaceInfo?.id,
      hotelId: singleSpaceInfo?.hotelId,
      name: name,
      description: area,
      cost: perPersonCost,
      adultCost: perPersonCost,
      childCost: perChildCost,
      taxId: taxId?.is_group_tax === "false" ? taxId?.id : null,
      groupTaxId: taxId?.is_group_tax === "true" ? taxId?.id : null,
    };

    setLoading(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental/create-update-non-rental-package`,
      payload
    )
      .then((res) => {
        toast.success(res);
        setGridRefresh(new Date());
      })
      .catch(() => toast.error("Error in adding/updating package."))
      .finally(() => {
        setOpenAddEditConfig(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAllTaxes();
  }, []);

  useEffect(() => {
    if (selectedRoom?.name) {
      setName(selectedRoom?.name);
      setArea(selectedRoom?.description);
      setTaxId(
        selectedRoom?.taxId > -1
          ? taxes.find((item) => item.id === selectedRoom?.taxId)
          : selectedRoom?.groupTaxId > -1
          ? taxes.find((item) => item.id === selectedRoom?.groupTaxId)
          : zeroTax?.[0]
      );
      setPerPersonCost(selectedRoom?.adultCost);
      setPerChildCost(selectedRoom?.childCost);
    }
  }, [selectedRoom, taxes]);

  return (
    <Box sx={{ paddingX: 2, maxWidth: 600, margin: "0 auto" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          paddingY: 2,
        }}
      >
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          {singleSpaceInfo?.name} Package Configuration
        </Typography>
        <IconButton onClick={() => setOpenAddEditConfig(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Grid container spacing={2}>
        {/* Room Name */}
        <Grid item xs={12}>
          <TextField
            label="Package Name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </Grid>

        {/* Area */}
        <Grid item xs={12}>
          <TextField
            label="Description"
            fullWidth
            value={area}
            onChange={(e) => setArea(e.target.value)}
          />
        </Grid>
        {/* Per Person Cost */}
        <Grid item xs={6}>
          <TextField
            label="Package Cost"
            fullWidth
            value={perPersonCost}
            onChange={(e) =>
              /^[0-9.-]*$/.test(e.target.value) &&
              setPerPersonCost(e.target.value)
            }
          />
        </Grid>

        {/* Per Hour Tax ID */}
        <Grid item xs={6}>
          <TextField
            select
            label="Package Tax Id"
            name="packageTaxId"
            value={taxId}
            onChange={(e) => setTaxId(e.target.value)}
            fullWidth
          >
            {taxes.map((item, index) => (
              <MenuItem id={index} value={item}>
                {item.name}&nbsp;[{item.percentage} %] &nbsp;
                {String(item.is_group_tax) === "true" && (
                  <i style={{ fontSize: "10px" }}>(Group tax)</i>
                )}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        {+singleSpaceInfo?.globalNonRentalTypeId === 4 && (
          <Grid item xs={12}>
            <TextField
              label="Per Child Cost"
              fullWidth
              value={perChildCost}
              onChange={(e) =>
                /^[0-9.-]*$/.test(e.target.value) &&
                setPerChildCost(e.target.value)
              }
            />
          </Grid>
        )}

        {/* Submit */}
        <Grid item xs={12}>
          <Button
            variant="custom-button"
            fullWidth
            onClick={handleAddUpdateSpace}
            disabled={loading}
          >
            Save Room Details
            {loading && (
              <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
            )}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddUpdatePackageConfig;
